import { GetHealthInsuranceByPatient } from 'domain/usecases/patient/get-health-insurance-by-patient'
import { PatientNewRepository } from 'repository/interfaces/patient-new-repository'

export class RemoteGetHealthInsuranceByPatient
  implements GetHealthInsuranceByPatient
{
  private readonly patientNewRepository: PatientNewRepository

  constructor(patientNewRepository: PatientNewRepository) {
    this.patientNewRepository = patientNewRepository
  }

  get(
    params: GetHealthInsuranceByPatient.Params
  ): Promise<GetHealthInsuranceByPatient.Model> {
    return this.patientNewRepository.getHealthInsuranceByPatient(params)
  }
}
